import {routes as auth} from './domains/auth'
import {routes as registration} from './domains/registration'
import {routes as submission} from './domains/submission'
import {routes as evaluation} from './domains/evaluation'
import {routes as presence} from './domains/presence'

export default [
  ...auth,
  ...registration,
  ...submission,
  ...evaluation,
  ...presence
]
